export var ConfigOption;
(function (ConfigOption) {
    ConfigOption["DEDUCTION_LINE"] = "DEDUCTION_LINE";
})(ConfigOption || (ConfigOption = {}));
